import React, { Component } from 'react';

export class WizardForm extends Component {
  state = {
    currentStep: 0,
    isGoingBack: false
  };
  nextStep = values => {
    let currentStep = this.state.currentStep + 1;
    if (currentStep === this.props.steps.length) {
      this.props.onSubmit(values);
    }
    this.setState({ currentStep, isGoingBack: false });
  };
  prevStep = () => {
    let currentStep = this.state.currentStep - 1;
    if (currentStep >= 0) {
      this.setState({ currentStep, isGoingBack: true });
    }
  };
  continue = () => {
    if (this.state.isGoingBack) {
      this.prevStep();
    } else {
      this.nextStep();
    }
  };
  render() {
    if (
      !this.props.steps ||
      !this.props.steps.length ||
      this.state.currentStep >= this.props.steps.length
    ) {
      return false;
    }
    let CurrentComponent = this.props.steps[this.state.currentStep];
    return (
      <CurrentComponent
        onSubmit={this.nextStep}
        handleBack={this.prevStep}
        continue={this.continue}
        {...this.props.props}
      />
    );
  }
}

export default WizardForm;



// WEBPACK FOOTER //
// ./src/components/forms/wizardform/WizardForm.js